export default "__VITE_ASSET__BA01icpu__"